import { OrderModel } from '../../api/index';
import { Injectable } from '@angular/core';
import { I18n } from '@ngx-translate/i18n-polyfill';

@Injectable({
  providedIn: 'root'
})
export class OrderMapsServices {

  constructor(private i18n: I18n) {}

  STATUSES = {
    [OrderModel.StatusEnum.Verified]: {
      text: this.i18n('Проверен'),
      background: '#4caf50',
      color: '#ffffff'
    },
    [OrderModel.StatusEnum.Created]: {
      text: this.i18n('Новый'),
      background: '#ffeb3b',
      color: '#3f3f3f'
    },
    [OrderModel.StatusEnum.Paid]: {
      text: this.i18n('Оплачен'),
      background: '#4caf50',
      color: '#ffffff'
    },
    [OrderModel.StatusEnum.InRent]: {
      text: this.i18n('В аренде'),
      background: '#007bff',
      color: '#ffffff'
    },
    [OrderModel.StatusEnum.Acceptance]: {
      text: this.i18n('Приемка'),
      background: '#9e9e9e',
      color: '#ffffff'
    },
    [OrderModel.StatusEnum.Rejected]: {
      text: this.i18n('Отменён'),
      background: '#f44336',
      color: '#ffffff'
    },
    [OrderModel.StatusEnum.Closed]: {
      text: this.i18n('Закрыт'),
      background: '#9e9e9e',
      color: '#ffffff'
    },
    [OrderModel.StatusEnum.Acceptance]: {
      text: this.i18n('Приемка'),
      background: '#ffeb3b',
      color: '#3f3f3f'
    },
  };

  PERIODS = {
    [1]: {
      text: this.i18n('1 сутки'),
      background: '#4caf50',
      color: '#ffffff'
    },
    [7]: {
      text: this.i18n('7 суток'),
      background: '#ffeb3b',
      color: '#3f3f3f'
    },
    [30]: {
      text: this.i18n('30 суток'),
      background: '#4caf50',
      color: '#ffffff'
    },
    [60]: {
      text: this.i18n('60 суток'),
      background: '#4caf50',
      color: '#ffffff'
    },
    [365]: {
      text: this.i18n('365 суток'),
      background: '#4caf50',
      color: '#ffffff'
    },
  };
}
